import React from 'react';
import { Link } from 'gatsby';
import { gdprEmbeddedCheck } from '../CookieConsent/embedded';
import CookieConsent, { Cookies } from 'react-cookie-consent';

export const CookCons = (props: Props) => {
	return (
		<CookieConsent
			location="bottom"
			buttonText="Accepter tous les cookies"
			enableDeclineButton={true}
			declineButtonText="Accepter uniquement les cookies fonctionels"
			cookieName="djn47-gdpr"
			containerClasses="container-djn47-gdpr"
			style={{
				background: 'rgb(53, 53, 53, 0.95)'
			}}
			buttonStyle={{
				color: '#FFFFFF',
				fontSize: '13px',
				background: '#dd0000',
				textTransform: 'uppercase'
			}}
			declineButtonStyle={{
				background: 'rgb(255, 212, 45)',
				color: '#000000',
				textTransform: 'uppercase'
			}}
			expires={365}
			onAccept={() => {
				gdprEmbeddedCheck();
			}}
		>
			Nous utilisons des cookies pour optimiser notre site web et notre service. <Link to={`/politique-de-cookies`} title="Politique de cookies" dangerouslySetInnerHTML={{ __html: 'Lire la suite' }} />
		</CookieConsent>
	);
};

export default CookCons;
